import { identityDocumentType } from '@repo/shared/types';

// Mirrors POST /api/loan validation: `other` is rejected, `idCard` must be Polish
export const isValidIdentityDocument = (type?: string | null, country?: string | null) => {
  const parsedType = identityDocumentType.safeParse(type);
  if (!parsedType.success) {
    return false;
  }

  switch (parsedType.data) {
    case 'idCard':
      return country === 'PL';
    case 'passport':
    case 'residenceCard':
      return true;
    case 'other':
      return false;
  }
};
